import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LinkButton,
  Grid,
  Heading,
  Box,
  BoxProps,
  Divider,
  useThemedValueSwitch,
  FormControl,
} from '@tq/ui-components';

import { ConsultationTypeFilter } from '../ConsultationTypeFilter';
import { ConsultationStatusFilter } from '../ConsultationStatusFilter';
import { ConsultationAssigneeFilter } from '../ConsultationAssigneeFilter';
import { ConsultationCategoryFilter } from '../ConsultationCategoryFilter';
import { ConsultationAuthorityFilter } from '../ConsultationAuthorityFilter';
import { ConsultationDateFilter } from '../ConsultationDateFilter';
import { ConsultationTeamFilter } from '../ConsultationTeamFilter';
import { useClearAllFilters } from 'hooks';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { spacing } from '@tq/ui-components/dist/components/mobile-options-accordion/styles/theme/spacing';

export const SideFilter: React.FC<BoxProps & { isLoading?: boolean }> = ({
  isLoading,
  ...stylingProps
}) => {
  const { t } = useTranslation('filter');
  const { tvs } = useThemedValueSwitch();

  const clearAllFilters = useClearAllFilters();

  return (
    <Box {...stylingProps} position='relative'>
      <Grid role='region' aria-labelledby='filter-options-title' gridGap={{ base: 3, lg: 5 }}>
        <Grid gridGap={5} mb={tvs({ ni: 5, tq: 3 })}>
          <Heading id='filter-options-title' size='md'>
            {t('filter_options', 'Filter options')}
          </Heading>
          <LinkButton onClick={clearAllFilters}>
            <strong>{t('clear_all_filters', 'Clear all filters')}</strong>
          </LinkButton>
        </Grid>
        <FormControl>
          <ConsultationTypeFilter />
          <ConsultationStatusFilter />
          <ConsultationAssigneeFilter />
          <Divider
            mx={-5}
            mt={1}
            width={`calc('100%' + ${spacing(10)})`}
            borderColor={COLOURS.gray[270]}
          />
          <ConsultationDateFilter />
          <Divider
            mx={-5}
            mt={1}
            width={`calc('100%' + ${spacing(10)})`}
            borderColor={COLOURS.gray[270]}
          />
          <ConsultationAuthorityFilter />
          <ConsultationCategoryFilter />
          <ConsultationTeamFilter />
        </FormControl>
      </Grid>
      {isLoading ? (
        <Box
          position='absolute'
          h='100%'
          background={COLOURS.gray[100]}
          opacity={0.5}
          w='100%'
          zIndex={1}
          top={0}
          left={0}
        />
      ) : null}
    </Box>
  );
};
